import React, { useState } from 'react';
import './App.css';

import ReactCardFlip from 'react-card-flip';

function Card({ index, item }) {

    const [isFlipped, setIsFlipped] = useState(false)

    const [hard, setHard] = useState(null)

    function handleClick() {
        setIsFlipped(!isFlipped)
    }

    function clickedEasy() {
        setIsFlipped(!isFlipped)
        setHard(false)
    }

    function clickedHard() {
        setIsFlipped(!isFlipped)
        setHard(true)
    }

    function getLevelCard() {
        if (hard == null) {
            return 'card_level_0'
        }
        else if (hard == false) {
            return 'card_level_1'
        }
        else if (hard == true) {
            return 'card_level_2'
        }
    }

    return (
        <ReactCardFlip isFlipped={isFlipped}>
            <div class={getLevelCard()} onClick={handleClick}>
                <div class="number">
                    {index}
                </div>
                <div>
                    <p class="text_en">{item.e}<br/><span class="text_en2">{item.t}</span></p>
                </div>
            </div>

            <div class='card_level_0'>
                <div class="number">
                    {index}
                </div>
                <div class="text_pl">
                    {item.p}
                </div>
                <div class="buttons">
                    <div class="button-view">
                        <button class="button" onClick={clickedEasy}>EASY</button>
                    </div>
                    <div class="button">
                        <button class="button" onClick={clickedHard}>HARD</button>
                    </div>
                </div>
            </div>
        </ReactCardFlip>
    );
}

export default Card;